<template>
    <el-dialog
            :visible.sync="showModel"
            :show-close="false"
            :modal="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="dialog-dark"
            top="30%"
            width="80%"
            custom-class="commDialog">
        <!--todo Touch ID-->
        <div class="container" v-if="isTouchId">
            <img src="@/assets/images/dialog_touch.svg" class="icon">
            <span class="outer-content">請用Touch ID登入</span>
            <div class="dialog-footer">
                <el-button @click="isTouchId=false" round type="primary">密碼認證</el-button>
            </div>
        </div>
        <!--todo 輸入密碼-->
        <div class="container" v-if="!isTouchId">
            <img src="@/assets/images/dialog_password.svg" class="icon">
            <div class="outer-content mb-2">請輸入支付密碼</div>
            <div class="text-center mb-3">
                <input
                        ref="n1"
                        class="pay-password"
                        type="tel"
                        @keyup="nextInput('n2')"
                        @keyup.delete="backInput('n1')"
                        maxlength="1"
                        pattern="[0-9]*"/>
                <input
                        ref="n2"
                        class="pay-password"
                        type="tel"
                        @keyup="nextInput('n3')"
                        @keyup.delete="backInput('n1')"
                        maxlength="1"
                        pattern="[0-9]*"/>
                <input
                        ref="n3"
                        class="pay-password"
                        type="tel"
                        @keyup="nextInput('n4')"
                        @keyup.delete="backInput('n2')"
                        maxlength="1"
                        pattern="[0-9]*"/>
                <input
                        ref="n4"
                        class="pay-password"
                        type="tel"
                        @keyup="nextInput('n5')"
                        @keyup.delete="backInput('n3')"
                        maxlength="1"
                        pattern="[0-9]*"/>
                <input
                        ref="n5"
                        class="pay-password"
                        type="tel"
                        @keyup="nextInput('n6')"
                        @keyup.delete="backInput('n4')"
                        maxlength="1"
                        pattern="[0-9]*"/>
                <input
                        ref="n6"
                        class="pay-password"
                        type="tel"
                        @keyup="submit"
                        @keyup.delete="backInput('n5')"
                        maxlength="1"
                        pattern="[0-9]*"/>
            </div>
            <!--todo 有設定Touch ID才出現以下-->
            <div class="dialog-footer">
                <el-button @click="isTouchId=true" round type="primary">Touch ID</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "PasswordDialog",
        props: {
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
        },
        data() {
            return {
                showModel: this.value,
                isTouchId: true,//是否有開啟TouchId
            }
        },
        created() {


        },
        mounted() {
        },
        watch: {
            value: function () {
                this.showModel = this.value;
            },
        },
        methods: {


            nextInput(type) {
                //輸入後後跳下一個
                this.$refs[type].focus()
            },
            backInput(type) {
                //刪除後往前一個
                this.$refs[type].focus()
            },
            submit() {
                this.showModel = false
                this.$emit('result', false, this.eventType);
            }
        }
    }
</script>

<style scoped lang="less">
    .el-dialog__wrapper.dialog-dark{
        background: url("../../../assets/images/Default-667h.png");
        background-size: cover;
    }
</style>